export const useNumberLocaleConfig = () => {
  const locale = window.navigator.language || 'ru'
  const numberWithDecimal = 12_345.6

  const parts = Intl.NumberFormat(locale).formatToParts(numberWithDecimal)
  const decimal = parts.find(part => part.type === 'decimal')?.value
  const group = parts.find(part => part.type === 'group')?.value

  return { decimal: decimal || '.', group: group || ' ' }
}
